import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface OtherFinancialAssetsInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function OtherFinancialAssetsInternalControls({
  onBack,
  setActiveSection,
  controlsListSection,
}: OtherFinancialAssetsInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Other Financial Assets"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}

